"use strict";

// Função para carregar scripts de forma assíncrona
function loadScript(url, callback) {
  var script = document.createElement('script');
  script.src = url;
  script.type = 'text/javascript';
  script.async = true;
  script.onload = callback;
  document.head.appendChild(script);
}

Date.prototype.toJSON = function () {
  return moment(this).toISOString();
};

angular.module(
  ApplicationConfiguration.applicationModuleName,
  ApplicationConfiguration.applicationModuleVendorDependencies
);

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .constant("apiSettings", window.config);

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .constant("systemMessages", window.systemMessages);

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .constant("enumerators", window.enumerators);

angular.module("ngRateIt", []);

angular.module(ApplicationConfiguration.applicationModuleName).config([
  "$httpProvider",
  function ($httpProvider) {
    // Date format
    var regexIso8601 =
      /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)/;

    var convertDateStringsToDates = function (input) {
      // Ignore things that aren't objects.
      if (typeof input !== "object") return input;

      for (var key in input) {
        if (!input.hasOwnProperty(key)) continue;

        var value = input[key];
        var match;

        // Check for string properties which look like dates.
        if (typeof value === "string" && (match = value.match(regexIso8601))) {
          var milliseconds = Date.parse(match[0]);

          if (!isNaN(milliseconds)) {
            input[key] = moment.utc(milliseconds).toDate();
          }
        } else if (typeof value === "object") {
          // Recurse into object
          convertDateStringsToDates(value);
        }
      }
    };

    $httpProvider.defaults.transformResponse.push(function (response) {
      convertDateStringsToDates(response);

      return response;
    });

    // $httpProvider
    $httpProvider.interceptors.push("authInterceptorService");
  },
]);


angular.module(ApplicationConfiguration.applicationModuleName).run([
  "$rootScope",
  "$state",
  "settings",
  function ($rootScope, $state, settings) {
    $rootScope.$on("$stateChangeStart", (event, toState) => {
      if (toState.name === "main.colorrequestexternal") {
        const hasAccess = settings.isColorsUserGroupByName('ControleQualidade');
        if (!hasAccess) {
          event.preventDefault();
          $state.go("main.colorrequest");
        }
      }
    });
  },
]);

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .factory("$exceptionHandler", function ($injector) {
    // Referência para evitar falha de dependência circular
    // https://stackoverflow.com/questions/22332130/injecting-http-into-angular-factoryexceptionhandler-results-in-a-circular-de
    return function (exception, cause) {
      var $log = $injector.get("$log");
      var MessageService = $injector.get("MessageService");

      MessageService.alertError(exception);
      $log.warn(exception, cause);
    };
  });

// Ladda
angular.module(ApplicationConfiguration.applicationModuleName).config([
  "laddaProvider",
  function (laddaProvider) {
    laddaProvider.setOption({
      style: "expand-left",
      spinnerSize: 35,
      spinnerColor: "#ffffff",
    });
  },
]);

// Flow
angular.module(ApplicationConfiguration.applicationModuleName).config([
  "flowFactoryProvider",
  function (flowFactoryProvider) {
    flowFactoryProvider.defaults = {
      target: "/upload",
      permanentErrors: [404, 500, 501],
      minFileSize: 0,
    };
  },
]);

// Translation
angular.module(ApplicationConfiguration.applicationModuleName).config([
  "$translateProvider",
  "apiSettings",
  function ($translateProvider, apiSettings) {
    $translateProvider.useStaticFilesLoader({
      prefix: apiSettings.rootLangFolder + "/lang/",
      suffix: ".json",
    });

    $translateProvider.preferredLanguage("pt-BR");

    $translateProvider.useSanitizeValueStrategy("escape");
  },
]);

angular.module(ApplicationConfiguration.applicationModuleName).run([
  "$rootScope",
  "$log",
  "$ngConfirm",
  "$state",
  "settings",
  function ($rootScope, $log, $ngConfirm, $state, settings) {
    $rootScope.$on(
      "$stateChangeError",
      function (event, toState, toParams, fromState, fromParams, error) {
        $log.warn(error);

        $ngConfirm({
          title: "Ocorreu um erro...",
          icon: "glyphicon glyphicon-exclamation-sign",
          content: error.data,
          theme: "supervan",
          type: "red",
          scope: $rootScope,
          buttons: {
            ok: {
              keys: ["enter"],
              action: function (scope) {
                if (
                  error.data == null ||
                  error.data == window.systemMessages.sessionExpired
                ) {
                  settings.signOut();
                  settings.setRedirect(toState, toParams);
                  $state.go("login");
                }
              },
            },
          },
        });
      }
    );

  },
]);

angular.module(ApplicationConfiguration.applicationModuleName).run([
  "defaultErrorMessageResolver",
  function (defaultErrorMessageResolver) {
    defaultErrorMessageResolver.setI18nFileRootPath(
      window.config.rootLangFolder + "/lang/angular-auto-validate"
    );

    defaultErrorMessageResolver.setCulture("pt-BR");

    // Mensagens de erro customizadas
    defaultErrorMessageResolver
      .getErrorMessages()
      .then(function (errorMessages) {
        errorMessages["required"] = "Campo obrigatório";
        errorMessages["brPhoneNumber"] = "Telefone inválido";
        errorMessages["cep"] = "CEP inválido";
        errorMessages["editable"] = "";
        errorMessages["invalidCustomer"] = "Cliente inválido";
        errorMessages["invalidColor"] = "Cor inválida";
        errorMessages["date-after-or-equal"] = "Data inválida";
        errorMessages["startAfterEnd"] = "Período inválido";
        errorMessages["startBeforeSysDate"] = "Início inválido";
        errorMessages["invalidCpfCnpj"] = "CPF/CNPJ inválido";
      });
  },
]);

// Firebase Messaging
angular.module(ApplicationConfiguration.applicationModuleName).run(['settings', function (settings) {

  if (window.config.projectModule == 'Colors') {

    loadScript('https://www.gstatic.com/firebasejs/8.10.0/firebase-app.js', function () {
      loadScript('https://www.gstatic.com/firebasejs/8.10.0/firebase-messaging.js', function () {

        var firebaseConfig = {
          apiKey: "AIzaSyDwHAWIHQ1Gg_hl6l3-8i0Bhy20zSpQS44",
          authDomain: "sw-flow.firebaseapp.com",
          projectId: "sw-flow",
          storageBucket: "sw-flow.appspot.com",
          messagingSenderId: "235227703680",
          appId: "1:235227703680:web:cc027e55734a059b617965",
          measurementId: "G-4JY1QN7LN9"
        };

        // Inicializa o Firebase
        firebase.initializeApp(firebaseConfig);

        // Obtém a instância de messaging
        const messaging = firebase.messaging();

        // Verifica se o navegador suporta service workers
        if ('serviceWorker' in navigator) {
          navigator.serviceWorker.register('/firebase-messaging-sw.js')
            .then(function (registration) {
              // Aguarda a ativação do service worker
              return navigator.serviceWorker.ready;
            })
            .then(function (registration) {
              const messaging = firebase.messaging();
              messaging.useServiceWorker(registration);

              // Solicita permissão ao usuário
              return messaging.requestPermission();
            })
            .then(function () {
              // Obtem o token do usuário
              return messaging.getToken({ vapidKey: 'BJkpnlQR2t5HURhdNQIzW-TCBBsuJy0Z9Rc2pAXtg9PXILm2C_N9o_dhpFpGgHj8r2pLT_Ar-GhuaKonu78uhxU' });
            })
            .then(function (token) {
              // Envia o token para o backend
              settings.setWebPushToken(token);
            })
            .catch(function (err) {
              console.error('[core.application] messaging.getToken fail', err);
            });
        }
      });
    });

  }

}]);